import { setTerm } from './helpers';

/**
 * @todo: Код появился в задаче CD-250097, удалить в задаче CD-250490.
 */
export const setBlackFridayEtazhi = setTerm('is_black_friday_etazhi');
